export const tenantOverrideAllowedFor = [
  "api/app/driveractivity/",
  "api/app/driverlogs/",
  "api/app/driver/",
  "api/app/event",
  "api/app/masterevent",
  "api/app/hoslogs/",
  "api/app/vehicleview/",
  "api/app/driverview/",
  "api/app/eventview/",
  "report/",
  "api/app/fmcsainspection/",
  "api/app/fmcsatransfer/",
];
